import { ICONS, getIconSize } from '@talktoast/shared'

interface ValueProp {
  icon: React.ComponentType<{ className?: string }>
  title: string
  description: string
  emoji: string
}

const valueProps: ValueProp[] = [
  {
    icon: ICONS.utility.messageCircle,
    emoji: '💬',
    title: 'Conversational Planning',
    description: 'Talk to our AI chef like a friend. No complicated forms or endless scrolling.',
  },
  {
    icon: ICONS.navigation.shoppingBag,
    emoji: '🛒',
    title: 'One-Click Shopping',
    description: 'Instant Instacart integration. Your grocery list is ready before you know it.',
  },
  {
    icon: ICONS.navigation.calendar,
    emoji: '📅',
    title: 'Calendar Magic',
    description: 'Drag, drop, cook. Schedule your meals visually and export to any calendar.',
  },
  {
    icon: ICONS.utility.heart,
    emoji: '❤️',
    title: 'Dietary Freedom',
    description: 'Every meal plan respects your preferences, restrictions, and favorite cuisines.',
  },
]

export function ValueProps() {
  return (
    <section id="features" className="py-16 md:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-deep-charcoal mb-4">
            Why You'll Love TalkToast
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            Everything you need to plan, shop, and cook with confidence
          </p>
        </div>

        {/* Value Props Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {valueProps.map((prop, index) => {
            const IconComponent = prop.icon
            return (
              <div
                key={index}
                className="text-center group hover:transform hover:-translate-y-1 transition-all duration-300"
              >
                {/* Icon Container */}
                <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-toast-gold/10 to-toast-gold/5 rounded-full mb-4 group-hover:shadow-lg transition-shadow">
                  <IconComponent className={`${getIconSize('lg')} text-toast-gold-700`} />
                </div>

                {/* Title */}
                <h3 className="text-xl md:text-2xl font-semibold mb-2 text-deep-charcoal">
                  {prop.title}
                </h3>

                {/* Description */}
                <p className="text-base md:text-lg text-gray-600 leading-relaxed">
                  {prop.description}
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
